import React from 'react';
import './style.css';

export interface IAppStepperStepProps {
  index: number;
  label: string;
  component: React.ReactNode;
  error?: boolean;
  disabled?: boolean;
  containerStyle?: React.CSSProperties;
  activeContainerStyle?: React.CSSProperties;
  circleStyle?: React.CSSProperties;
  circleActiveStyle?: React.CSSProperties;
}

interface IAppStepperProps {
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  stepsWithError?: number[];
  steps: IAppStepperStepProps[];
}

const AppStepper = ({ activeIndex, setActiveIndex, stepsWithError, steps }: IAppStepperProps) => {
  return (
    <div className="app-stepper">
      <div className="app-stepper-header">
        <div className="app-stepper-steps">
          {steps.map((step, index) => {
            const isActive = index === activeIndex;
            const hasError = stepsWithError ? stepsWithError.includes(index) : false;
            const isDisabled = step.disabled;

            return (
              <div
                key={index}
                onClick={() => !isDisabled && setActiveIndex(index)}
                className={`app-stepper-step ${isActive ? 'active' : ''} ${hasError ? 'error' : ''} ${isDisabled ? 'disabled' : ''}`}
                style={{
                  ...step.containerStyle,
                  ...(isActive ? step.activeContainerStyle : {}),
                }}
              >
                <div
                  className={`app-stepper-circle ${isActive ? 'active' : ''} ${hasError ? 'error' : ''} ${isDisabled ? 'disabled' : ''}`}
                  style={{
                    ...step.circleStyle,
                    ...(isActive ? step.circleActiveStyle : {}),
                  }}
                >
                  {index + 1}
                </div>
                <div>{step.label}</div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="app-stepper-content">{steps[activeIndex] && steps[activeIndex].component}</div>
    </div>
  );
};

export default AppStepper;
